// extracted by mini-css-extract-plugin
export var search = "SearchBar-module--search--G913+";
export var search_bar = "SearchBar-module--search_bar--HVRGG";
export var search_icon = "SearchBar-module--search_icon--UOBVi";
export var search_text = "SearchBar-module--search_text--iNu7h";